import { io, type Socket } from 'socket.io-client';
import { env } from '@/config/env';
import { getAccessToken } from '@/store/authStore';

/**
 * Socket.IO client factory for authenticated real-time features (notifications,
 * live updates — spec §25). The access token is passed via `auth` so the backend
 * gateway can authorise the connection. Connection is opened lazily by the feature
 * that needs it; created here so later phases share one configured client.
 */
export function createSocket(namespace = ''): Socket {
  const url = env.socketUrl ? `${env.socketUrl}${namespace}` : namespace || '/';
  return io(url, {
    autoConnect: false,
    withCredentials: true,
    transports: ['websocket'],
    auth: (cb) => cb({ token: getAccessToken() ?? '' }),
  });
}
